import { Analytics } from '@util/Analytics';
import { SharedAssessmentKeys } from 'hydra-data-types';
import React, { ReactElement } from 'react';
import { stripUndefined } from 'ts-utils';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { useAppStore } from '../../store/Store';
import { dispatchUserData } from '../../store/userData/UserDataActions';
import { NavigationProps } from './FlowNavigation';
import { SingleInputLayout, SingleInputLayoutConfig } from './layouts/SingleInputLayout';

export type SingleInputScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.SingleInput,
  SingleInputLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  SingleInputScreenConfig<ScreenNames>,
  ScreenNames
>;

export const SingleInputScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const prefillValue = useAppStore(
    (state) => state.userData[props.screenName as SharedAssessmentKeys]?.[0]
  );

  function onSubmitPress(value: string): void {
    dispatchUserData({ [props.screenName]: [value] });

    Analytics.track({
      event: Analytics.Event.o_question_answered,
      ...stripUndefined({
        question: props.screenName,
        answer: props.layout.collectsPIIData ? undefined : value,
      }),
    });
    props.navigation.next(props);
  }

  return (
    <SingleInputLayout
      {...props.layout}
      onPressPrimaryButton={onSubmitPress}
      selected={prefillValue}
    />
  );
};
